module.exports = __webpack_public_path__ + "static/media/icono3_bar_menu.76a688ff.webp";